module.exports = __webpack_public_path__ + "static/img/baselineRepair_pic03.8fddb7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baselineRepair/baselineRepair_pic03.png
// module id = 468
// module chunks = 1